module.exports = __webpack_public_path__ + "static/media/30OIOS4.7ee348d5.jpg";